import React from 'react';
import {FlatList, Pressable, View} from 'react-native';
import Text from '../../components/elements/Text';
import Button from '../../components/elements/Button';
import makeStyles from './styles.web';
import {useTheme, useThemedStyles} from '../../theme';
import {BUTTON_TYPES} from '../../utils/Constants';
import Divider from '../../components/elements/Divider';
import CommonStyles from '../../utils/CommonStyles';
import {tID} from '../../utils/TestIdHelper';
import {EmptyAddresses, PlusIcon} from '../../utils/SvgIcons';

const UI = ({
  addresses,
  renderListItem,
  onPressNewAddress,
  renderDeleteAddressConfirmation,
  isFromCheckout,
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <View
      testID={tID('MyAddresses-View-Main')}
      style={isFromCheckout ? styles.checkoutContainer : styles.container}>
      <View
        style={
          addresses?.length && !isFromCheckout
            ? styles.contentContainer
            : CommonStyles.full_flex
        }>
        {!isFromCheckout && (
          <Text
            testID={tID('MyAddresses-Text-Title')}
            variation="Headline4SemiBold22"
            color={colors.textSecondary}>
            My Addresses
          </Text>
        )}
        <Divider />
        <FlatList
          data={addresses}
          keyExtractor={(item, index) => index}
          renderItem={renderListItem}
          style={styles.list}
        />
        {addresses?.length ? (
          <View>
            <Divider top={-1} />
            <Pressable
              testID={tID('MyAddresses-Pressable-Add')}
              onPress={onPressNewAddress}
              style={styles.addNewAddressText}>
              <PlusIcon width={10} height={10} style={CommonStyles.mr_8} />
              <Text
                testID={tID('MyAddresses-Text-Add')}
                variation="Text1SemiBold"
                color={colors.link}>
                Add New Address
              </Text>
            </Pressable>
          </View>
        ) : null}
      </View>

      {!addresses?.length ? (
        <View
          testID={tID('MyAddresses-View-EmptyListContainer')}
          style={styles.emptyListContainer(isFromCheckout)}>
          <EmptyAddresses />
          <Text
            testID={tID('MyAddresses-Text-NoAddress1')}
            variation="Text1SemiBold"
            topMargin={16}
            color={colors.textSecondary}>
            No Addresses Added Yet
          </Text>
          <Text
            testID={tID('MyAddresses-Text-NoAddress2')}
            variation="Text2Regular"
            topMargin={8}
            color={colors.textTertiary}>
            Your added addresses will be available for you when checkout.
          </Text>
          <Button
            testID={tID('MyAddresses-Button-Add')}
            onPress={onPressNewAddress}
            title={'Add New Address'}
            buttonType={BUTTON_TYPES.Filled}
            titleColor={colors.textOnAccent}
            topMargin={32}
            style={styles.addNewAddressButton}
          />
        </View>
      ) : null}
      {renderDeleteAddressConfirmation()}
    </View>
  );
};

export default UI;
